import React from 'react'
import { useEffect } from 'react';
import { useInView }from 'react-intersection-observer'

function Social() {

    const { ref , inView } = useInView({threshold : 0.2});

    useEffect(()=>{
        if(inView){
            document.querySelectorAll(".home__social-icon").forEach((item)=>{
                item.style.transform =  "translateX(0px)"
                item.style.opacity =  1
            })
        }
        else {
            document.querySelectorAll(".home__social-icon").forEach((item)=>{
                item.style.transform =  "translateX(-100px)"
                item.style.opacity =  0
            })
        }
    })



    return (
        <div  ref={ref} className="home__social">
            <a    href="https://www.instagram.com/its_me__manas/" className="home__social-icon" target="_blank">
                <i className="uil uil-instagram"></i>
            </a>
            <a    href="https://www.linkedin.com/in/manasupadhyay1813/" className="home__social-icon " style={{"transitionDelay":" 0.2s"}} target="_blank">
                <i className="uil uil-linkedin-alt"></i>
            </a>
            <a    href="https://github.com/ManasUpadhyay13" className="home__social-icon " style={{"transitionDelay":" 0.4s"}} target="_blank">
                <i className="uil uil-github-alt"></i>
            </a>
            <a   href="https://twitter.com/its_me__manas" className="home__social-icon " style={{"transitionDelay":" 0.6s"}} target="_blank">
                <i className="uil uil-twitter-alt"></i>
            </a>
        </div>
    )
}

export default Social